/**
 * How a feature's copy is written: one file in `copy/`, all its languages together. Run by plain Node as well
 * (scripts/discover.mjs reads the files to list them), so only syntax Node can strip is used here.
 */

export type Widen<T> = T extends string ? string : { [K in keyof T]: Widen<T[K]> };
export type DeepPartial<T> = T extends string ? string : { [K in keyof T]?: DeepPartial<T[K]> };

export interface NamespaceCopy<E extends object> {
  /**
   * True when every screen needs these words at once (the frame, signing in, Home). The rest is fetched when a
   * screen first needs it.
   */
  readonly base?: true;
  /** English is the source: its keys are the keys `t()` accepts. */
  readonly en: E;
  /** Danish is live, so it must have every key English has. */
  readonly da: Widen<E>;
  /** Switched off until a native reader has reviewed them: any part of English, missing keys read English. */
  readonly sv?: DeepPartial<E>;
  readonly de?: DeepPartial<E>;
  readonly fr?: DeepPartial<E>;
  readonly es?: DeepPartial<E>;
}

/** The default export of every `copy/<feature>.ts`. */
export function defineCopy<const E extends object>(copy: NamespaceCopy<E>): NamespaceCopy<E> {
  return copy;
}
